// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"EndUserSidebar_sidebar__1I3QQ","content":"EndUserSidebar_content__1cOzW","time":"EndUserSidebar_time__2ItkV"};